import { defineStore } from "pinia";
import { api } from "@/shared/resource/apis/baseApi";
import { OPERATOR } from "@/shared/resource/apis/endpoints";
import { OPERATOR_INFORMATION } from "@/shared/resource/constants";
import { dateTime } from "@/shared/utills/date";
export const useOperatorStore = defineStore("operator", {
  state: () => ({
    entities: [],
    totalEntities: 0,
    information: [...OPERATOR_INFORMATION],
  }),

  actions: {
    async addOperator(payload) {
      const response = await api.post(OPERATOR.POST, payload);
      return response.data;
    },

    clearEntities() {
      this.entities = [];
      this.totalEntities = 0;
    },

    async deleteOperator(id) {
      const response = await api.delete(OPERATOR.DELETE(id));
      return response.data;
    },

    async fetch({ page = 1, limit = 10, filters = {} }) {
      this.clearEntities();
      const response = await api.get(OPERATOR.GET, {
        params: { page_no: page, limit, ...filters },
      });
      const data = response?.data?.data || [];

      const formattedEntities = data.map((operator) => ({
        uuid: operator.id,
        id: operator.operator_id,
        name: operator.name,
        createdAt: dateTime.formatDate(operator.created_at),
        phoneNumber: operator.phone_number,
        email: operator.email,
        fleetSize: operator.fleet_size,
        revenue: operator.revenue,
        bookings: operator.total_booking,
        onbordingProgress: `${operator.onboarding_progress}%`,
        role: operator.role,
        status: operator.is_active,
      }));

      this.setEntities(formattedEntities, response.data.total_entries || 0);
      this.setInformation(response.data);
      return formattedEntities;
    },

    async getOperatorById(id) {
      const response = await api.get(OPERATOR.GET_BY_ID(id));
      return response.data;
    },

    setEntities(entities, totalEntities) {
      this.entities = entities;
      this.totalEntities = totalEntities;
    },

    setInformation(info) {
      const { active_operators, in_complete_operators, total_active_buses } =
        info;
      this.information[0].count = active_operators;
      this.information[1].count = in_complete_operators;
      this.information[2].count = total_active_buses;
    },

    async updateOperator(id, payload) {
      const response = await api.put(OPERATOR.UPDATE(id), payload);
      return response.data;
    },

    async addKyc(payload) {
      const response = await api.post(OPERATOR.ADD_KYC, payload);
      return response.data;
    },

    async updateKyc(id, payload) {
      const response = await api.put(OPERATOR.UPDATE_KYC(id), payload);
      return response.data;
    },
  },

  getters: {
    getEntities: (state) => state.entities,
    getInformation: (state) => state.information,
    getTotalEntities: (state) => state.totalEntities,
  },
});
